import { Box, Button, HStack, Heading, Input, Spinner, Text, VStack } from '@chakra-ui/react';
import { HTTP } from '@utils/http';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { resolveUserError } from 'utils/userErrorMessages';

export function ResetPasswordForm() {
  const [email, setEmail] = useState<string>('');
  const [errorPwd, setErrorPwd] = useState<string>('');
  const [resetPwdConfirmation, setResetPwdConfirmation] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    setIsLoading(true);
    event.preventDefault();
    try {
      // Effectuez la requête et obtenez la réponse complète
      const response = (await HTTP.post('/auth/resetPassword', { email }).send()) as any;

      if (response?.status === 200) {
        setResetPwdConfirmation(
          'Vous allez bientôt recevoir un email pour réinitialiser votre mot de passe. Pensez à consulter vos courriers indésirables.',
        );
      } else {
        throw new Error('Une erreur inattendue est survenue');
      }
    } catch (error: any) {
      const errorCode = error?.ErrorCode || error?.response?.data?.ErrorCode;

      let errorMessage: string;
      switch (errorCode) {
        case 'INVALID_EMAIL':
          errorMessage = "L'adresse email saisie n'est pas valide. Vérifiez la saisie, puis réessayez.";
          break;
        case 'USER_NOT_FOUND':
          errorMessage = "Aucun compte n'est associé à cette adresse. Vérifiez la saisie, ou créez un compte.";
          break;
        default: {
          const backendMessage = error?.Message || error?.response?.data?.Message || error?.message;
          const { title, description } = resolveUserError(
            'auth',
            backendMessage ? new Error(backendMessage) : undefined,
          );
          errorMessage = description ? `${title}. ${description}` : title;
        }
      }

      setErrorPwd(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box w="full">
      <HStack width="100%" justifyContent="space-between" margin="1em 0 2em">
        <Heading className="accountMainTitle" size="md" textTransform="uppercase">
          Réinitialiser le mot de passe
        </Heading>
        <Button variant="contained" onClick={() => navigate(-1)}>
          Retour
        </Button>
      </HStack>
      <VStack width="100%" margin="1em 0 2em">
        <form style={{ width: '40%' }} onSubmit={handleSubmit}>
          <HStack spacing={5}>
            <Input
              type="email"
              placeholder="Entrez votre email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" variant="contained" width={'200px'}>
              {isLoading ? <Spinner color="white" alignContent="center" size="sm" /> : 'Reset'}
            </Button>
          </HStack>
        </form>
        <Text color="red">{errorPwd}</Text>
        <Text>{resetPwdConfirmation}</Text>
      </VStack>
    </Box>
  );
}
